import Button from "../Button"
import { SurveyProgressCards } from "../SurveyProgressCards"
import { useContext } from "react"
import { SurveyContext } from "../Main/SurveyContext"
import SurveyIntroText from "../SurveyIntroText"
import Icon from "../Icon"
import { SurveyOverviewTexts } from "~/types/dataTypes"

export default function OnboardingOverview({
  onOpenSurvey,
  surveyEstimates,
  texts
}: {
  onOpenSurvey: (surveyId: string) => void
  surveyEstimates: Record<
    string,
    { name: string; estimatedTimeToComplete: number }
  >
  texts: SurveyOverviewTexts
}): JSX.Element {
  const context = useContext(SurveyContext)

  if (!context) return <></>

  const { nextSurvey } = context

  const handleNext = () => {
    if (!nextSurvey) {
      window.ReactNativeWebView.postMessage("navigateToMobileApp")
    } else {
      onOpenSurvey(nextSurvey)
    }
  }

  return (
    <div className="flex flex-col gap-5 pt-8 pb-24 px-4 bg-primary-100 items-center lg:h-full justify-center">
      <div className="flex flex-col gap-5">
        <p className="text-neutral-700 font-semibold text-center">
          Spørgeskemaer
        </p>

        <div className="flex flex-col gap-6 px-2">
          <SurveyIntroText texts={texts} />
          <div className="flex gap-2 items-center p-2 rounded-lg text-neutral-900 border-[1px] border-primary-200 mb-2">
            <div>
              <Icon name="infoCircle" className="w-6 h-6" />
            </div>
            <p className="text-sm">
              Spørgeskemaet gemmes først, når alle spørgsmål er udfyldt. Hvis du
              lukker spørgeskemaet undervejs, vil dine svar ikke blive gemt.
            </p>
          </div>
        </div>
        <SurveyProgressCards
          surveyEstimates={surveyEstimates}
          onOpenSurvey={onOpenSurvey}
        />
      </div>

      <Button type="submit" variant="basic" onClick={handleNext}>
        {nextSurvey ? "Besvar næste spørgeskema" : texts.continueButton}
      </Button>
    </div>
  )
}
